$(document).ready(function() {
    if ($('.slide-text__slideActive')[0]) {
        const scroller = $('.slide-text__slideActive');

        if (scroller.owlCarousel && $('.slide-text__slideItem').length > 1) {
            $(scroller).owlCarousel({
                margin: 1,
                items: 1,
                smartSpeed: 450,
                dots: true,
                nav: true,
                navRewind: false,
                loop: true,
                autoplay: true,
                autoplayTimeout: 10000,
                responsive: {
                    0: {
                        nav: false,
                    },
                    768: {
                        nav: true,
                    },
                },
            });
        }

        function startCounterAnimation(entry) {
            const counter = entry.target;
            const target = +counter.getAttribute('data-target');

            if (target === 1) {
                counter.innerText = target.toLocaleString();
                return;
            }

            const increment = target / 100;
            let currentValue = 0;

            const updateCounter = () => {
                if (currentValue < target) {
                    currentValue += increment;
                    counter.innerText = Math.ceil(currentValue).toLocaleString();
                    requestAnimationFrame(updateCounter);
                } else {
                    counter.innerText = target.toLocaleString();
                }
            };

            updateCounter();
        }

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    observer.unobserve(entry.target);
                    startCounterAnimation(entry);
                }
            });
        }, options);

        const counters = document.querySelectorAll('.counter-title span');
        counters.forEach(counter => {
            observer.observe(counter);
        });
    }
});
